/*
  <hover-video> — plays a card's background video while the card is hovered,
  then pauses + rewinds on leave. Wraps a muted/looped <video>.

  Skipped on touch / no-hover pointers (the image stays). Auto-upgrades when
  inserted, so it works after a theme-editor re-render too. The hovered card is
  the nearest .product-card / .collection-card ancestor.
*/
if (!customElements.get('hover-video')) {
  customElements.define('hover-video', class extends HTMLElement {
    connectedCallback() {
      if (!window.matchMedia('(hover: hover)').matches) return;
      var video = this.querySelector('video');
      var card = this.closest('.product-card, .collection-card, .showcase-card');
      if (!video || !card) return;

      card.addEventListener('mouseenter', function () {
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () { /* autoplay blocked */ });
      });
      card.addEventListener('mouseleave', function () {
        video.pause();
        video.currentTime = 0;
      });
    }
  });
}
